import { Flex } from '@chakra-ui/react';
import { OutlineCard, TextArea } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FormFieldAcceleratedPublication } from '@publishing-engine/domain/types/article';
import { get } from 'lodash';

const AcceleratedPublication = ({
  config
}: {
  config: FormFieldAcceleratedPublication;
}) => {
  const {
    formState: { errors },
    register,
    watch
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const error = get(errors, field);
  const acceleratedPublication = watch(field);

  return (
    <OutlineCard borderless padding={8}>
      <Flex flexDirection="column" gap={4}>
        <FieldLabel
          isRequired={validations.required}
          label={labels.main}
          subText={labels.subtitle}
        />
        <TextArea
          placeholder="Enter an appeal for Accelerated Publication"
          value={acceleratedPublication || ''}
          isInvalid={Boolean(error)}
          {...register(field)}
        />
      </Flex>
    </OutlineCard>
  );
};

export default AcceleratedPublication;
